import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '@/store'

const selectViewState = (state: RootState) => state.auth

export const selectIsAuthenticated = createSelector(
  selectViewState,
  (state) => state.isAuthenticated,
)
